/* eslint-disable max-len */
import {
  Component,
  ElementRef,
  ChangeDetectorRef,
  ViewChild,
  AfterViewChecked,
  AfterViewInit,
  HostBinding,
  Renderer2,
} from '@angular/core';
import { LayoutMapFragmentPosition } from 'src/app/components/shared/models/interface/layoutMapFragmentPosition.enum';
import { MapPosition } from 'src/app/components/shared/models/interface/mapPosition.enum';
import { OrderDistanceShared } from 'src/app/components/shared/models/interface/orderDistance.interface';
import { SimplyCoordinatesShared } from 'src/app/components/shared/models/interface/simplyCoordinates.interface';
import { sharedDeliveryConstants } from 'src/app/components/shared/sharedConstants/delivery.constants';
import { MuMapComponent } from 'src/app/components/shared/sharedModules/designSystem/mu-map/mu-map.component';
import { MuLayoutPageAndMapService } from 'src/app/components/shared/sharedProtos/layout/mu-layout-page-and-map.service';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';

import { Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { environment } from 'src/environments/environment';
import { LayoutContentColumnSize } from '../../models/interface/layoutContentColumnSize.interface';
import { LayoutContentTexts } from '../../models/interface/layoutContentTexts.interface';
import { LayoutMapFragmentContent } from '../../models/interface/layoutMapFragment.interface';
import { LayoutPageAndMapModalPositionFlags } from '../../models/interface/layoutPageAndMapModalPosition.flags';
import { LayoutPageAndMapPosition } from '../../models/interface/layoutPageAndMapPosition.enum';
import { MapElement } from '../../models/interface/mapElement.interface';
import { MapOptions } from '../../models/interface/mapOptions.interface';
import { AtlasType } from 'src/app/components/shared/sharedModules/designSystem/mu-atlas/interfaces/mu-atlas-types.interface';
import { Router } from '@angular/router';
// import { filter, map } from 'rxjs';

@Component({
  selector: 'app-layout-page-and-map',
  templateUrl: './layout-page-and-map.component.html',
  styleUrls: ['./layout-page-and-map.component.sass'],
})
export class LayoutPageAndMapComponent<ButtonFlagType>
  extends MuComponent
  implements AfterViewChecked, AfterViewInit
{
  @ViewChild('muMap', { read: ElementRef }) map: ElementRef;
  @ViewChild('muDesktopPlaceHolder', { read: ElementRef }) muDesktopPlaceHolder: ElementRef;
  @ViewChild('muMobilePlaceHolder', { read: ElementRef }) muMobilePlaceHolder: ElementRef;
  @ViewChild('muTopMobilePlaceHolder', { read: ElementRef }) muTopMobilePlaceHolder: ElementRef;

  // fragment position
  @ViewChild('muMapFragmentBottomPlaceHolder', { read: ElementRef })
  muMapFragmentBottomPlaceHolder: ElementRef;
  @ViewChild('muMapFragmentTopPlaceHolder', { read: ElementRef })
  muMapFragmentTopPlaceHolder: ElementRef;
  @ViewChild('muMapMobileFragmentBottomPlaceHolder', { read: ElementRef })
  muMapMobileFragmentBottomPlaceHolder: ElementRef;
  @ViewChild('muMapMobileFragmentTopPlaceHolder', { read: ElementRef })
  muMapMobileFragmentTopPlaceHolder: ElementRef;

  @HostBinding('style.width') className = '100%';

  muMap: MuMapComponent<any>;
  texts: LayoutContentTexts;
  element: ElementRef;
  columnSize: LayoutContentColumnSize;
  mapOptions: MapOptions = sharedDeliveryConstants.mapOptions;
  mobileMapPlaceHolder: string;
  mapPositionEnum = MapPosition;
  buttonFlag: ButtonFlagType;
  buttonFlagList: Flags<ButtonFlagType>;
  buttonDisabled: boolean;
  orderDistance: OrderDistanceShared;
  showOrderDistance: boolean;
  showAlertScheduleMx: boolean;
  // used to restore to base layout
  customMapFragmentClass: string;
  isDragActive: boolean;
  isRequestService: boolean = false;
  flagList = new Flags<LayoutPageAndMapModalPositionFlags>();
  LayoutPageAndMapModalPositionFlags = LayoutPageAndMapModalPositionFlags;

  /**
   * optional fragment content
   */
  private mapFragment: LayoutMapFragmentContent;
  private desktopMediaQuery: MediaQueryList;
  atlasType: AtlasType = AtlasType.LEAFLET;

  constructor(
    private layoutService: MuLayoutService,
    public layoutPageAndMapService: MuLayoutPageAndMapService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private muLayoutService: MuLayoutService,
    private router: Router
  ) {
    super();
    this.watch(this.layoutService.layoutMain).subscribe((element: ElementRef) => {
      this.element = element;
      this.element.nativeElement.classList.add('mu-full-layout-content');
    });
    this.watch(this.layoutPageAndMapService.columnSize).subscribe(
      (columnSize: LayoutContentColumnSize) => {
        this.columnSize = columnSize;
      }
    );
    this.watch(this.layoutPageAndMapService.texts).subscribe((texts: LayoutContentTexts) => {
      this.texts = texts;
    });
    this.watch(this.layoutPageAndMapService.mapOptions).subscribe((mapOptions: MapOptions) => {
      if (this.muMap) {
        this.mapOptions = mapOptions;
        if (this.muMap.mapOptions !== this.mapOptions) {
          this.muMap.updateMapOptions(this.mapOptions);
        }
      }
    });
    this.watch(this.layoutPageAndMapService.markers).subscribe((markers: MapElement[]) => {
      if (this.muMap) {
        this.muMap.updateMarkers(markers);
      }
    });
    this.watch(this.layoutPageAndMapService.markersPositionOnly).subscribe((markers: MapElement[]) => {
      if (this.muMap) {
        this.muMap.updateMarkersPositionOnly(markers);
      }
    });
    this.watch(this.layoutPageAndMapService.buttonFlag).subscribe(flag => {
      this.buttonFlag = flag as ButtonFlagType;
    });
    this.watch(this.layoutPageAndMapService.buttonFlagList).subscribe(flagList => {
      this.buttonFlagList = flagList as Flags<ButtonFlagType>;
    });
    this.watch(this.layoutPageAndMapService.buttonDisabled).subscribe((disabled: boolean) => {
      this.buttonDisabled = disabled;
    });
    this.watch(this.layoutPageAndMapService.orderDistance).subscribe(
      (orderDistance: OrderDistanceShared) => {
        this.orderDistance = orderDistance;
      }
    );
    this.watch(this.layoutPageAndMapService.showOrderDistance).subscribe(
      (showOrderDistance: boolean) => {
        this.showOrderDistance = showOrderDistance;
      }
    );
    this.watch(this.layoutPageAndMapService.isDrag).subscribe((value: boolean) => {
      this.isDragActive = value;
    });
    this.watch(this.layoutPageAndMapService.fitBounds).subscribe((value: boolean) => {
      this.muMap?.fitBounds(value);
    });
  }

  muOnInit(): void {
    this.setCountry();
    const today = new Date();
    this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)');
    this.showAlertScheduleMx =
      localStorage.getItem('_r_x_a') && (today.getHours() <= 7 || today.getHours() >= 22)
        ? true
        : false;
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.watch(this.layoutPageAndMapService.mobileMapPlaceHolder).subscribe(placeHolder => {
      this.mobileMapPlaceHolder = placeHolder;
      if (!this.desktopMediaQuery.matches && this.mobileMapPlaceHolder) {
        this.positionateMapAndFragment();
      }
    });
    this.watch(this.layoutPageAndMapService.mapFragment).subscribe(mapFragment => {
      if (this.mapFragment != null) {
        this.removeMapFragment();
      }
      this.setMapFragment(mapFragment);
    });
    this.desktopMediaQuery.addEventListener('change', () => {
      this.positionateMapAndFragment();
    });
    this.positionateMapAndFragment();

    this.watch(this.layoutPageAndMapService.askForBrowserLocation).subscribe(
      askForBrowserLocation => {
        if (askForBrowserLocation) {
          this.askForBrowserLocation();
        }
      }
    );

    this.watch(this.router.events).subscribe((route: any) => {
      const url = route?.routerEvent?.url || '';
      this.isRequestService =
        url.includes('solicitud-de-servicio') || url.includes('pago') ? true : false;
    });
  }

  muOnDestroy(): void {
    this.element?.nativeElement?.classList?.remove('mu-full-layout-content');
  }

  /**
   * set country by url
   */
  private async setCountry(): Promise<void> {
    try {
      const localCountry = await this.muLayoutService.getCountry();
      let geoName = '';
      for (const tmpCountry of environment.countries) {
        if (this.router?.url.includes(`/${tmpCountry.geoName.toLowerCase()}/`)) {
          geoName = tmpCountry.geoName;
        }
      }
      this.muLayoutService.changeCountryValue(
        geoName || localCountry?.geoName || environment.countries[0].geoName
      );
    } catch (e) { /* empty */ }
  }

  /**
   * set up map position for current screen
   */
  positionateMapAndFragment(): void {
    if (this.desktopMediaQuery.matches) {
      this.renderer.appendChild(this.muDesktopPlaceHolder.nativeElement, this.map.nativeElement);
      if (this.mapFragment?.content) {
        this.renderer.appendChild(
          this.getDesktopFragmentPlaceHolder().nativeElement,
          this.mapFragment.content.nativeElement
        );
      }
      return environment.guardClause;
    }
    if (this.mobileMapPlaceHolder) {
      if (this.mobileMapPlaceHolder === LayoutPageAndMapPosition.TOP) {
        this.renderer.appendChild(
          this.muTopMobilePlaceHolder.nativeElement,
          this.map.nativeElement
        );
        this.appendMobileMapContent();
        return environment.guardClause;
      }
      const mobilePlaceHolder = document.getElementById(this.mobileMapPlaceHolder);
      if (mobilePlaceHolder) {
        while (mobilePlaceHolder.firstChild) {
          mobilePlaceHolder.removeChild(mobilePlaceHolder.firstChild);
        }
        this.renderer.appendChild(mobilePlaceHolder, this.map.nativeElement);
      }
      this.appendMobileMapContent();
      return environment.guardClause;
    }
    this.renderer.appendChild(this.muMobilePlaceHolder.nativeElement, this.map.nativeElement);
    this.appendMobileMapContent();
  }

  /**
   * Append content in mobile mode
   */
  appendMobileMapContent() {
    if (this.mapFragment?.content) {
      if (this.mapFragment.mobileMapFragmentHolder) {
        const mobilePlaceHolder = document.getElementById(this.mapFragment.mobileMapFragmentHolder);
        if (mobilePlaceHolder) {
          this.renderer.appendChild(mobilePlaceHolder, this.mapFragment.content.nativeElement);
        }
        return environment.guardClause;
      }
      this.renderer.appendChild(
        this.getMobileFragmentPlaceHolder().nativeElement,
        this.mapFragment.content.nativeElement
      );
    }
  }

  /**
   * set ready map
   *
   * @param $event
   */
  onComponentReady($event: MuMapComponent<any>): void {
    this.muMap = $event;
    this.layoutPageAndMapService.setReadyMap(this.muMap);
  }

  /**
   * return content style class
   */
  get layoutContentClass() {
    if (this.layoutPageAndMapService.useOverflow) {
      return 'mu-layout-column-content-overflow';
    }
    return '';
  }

  /**
   * set map fragment associated
   *
   * @param mapFragment
   */
  private setMapFragment(mapFragment: LayoutMapFragmentContent) {
    this.mapFragment = mapFragment;
    if (this.mapFragment?.contentClass) {
      const desktopPlaceHolder = this.getDesktopFragmentPlaceHolder();
      const mobilePlaceHolder = this.getMobileFragmentPlaceHolder();
      this.renderer.addClass(desktopPlaceHolder.nativeElement, this.mapFragment.contentClass);
      if (mobilePlaceHolder) {
        this.renderer.addClass(mobilePlaceHolder.nativeElement, this.mapFragment.contentClass);
      }
    }
    if (this.mapFragment?.mapClass) {
      this.customMapFragmentClass = this.mapFragment?.mapClass;
      this.renderer.addClass(this.muDesktopPlaceHolder.nativeElement, this.mapFragment.mapClass);
      this.renderer.removeClass(this.muDesktopPlaceHolder.nativeElement, 'layout-map-fragment');
      if (!this.mobileMapPlaceHolder) {
        this.renderer.addClass(this.muMobilePlaceHolder.nativeElement, this.mapFragment.mapClass);
      }
    } else {
      if (this.customMapFragmentClass) {
        this.renderer.removeClass(
          this.muDesktopPlaceHolder.nativeElement,
          this.customMapFragmentClass
        );
        this.renderer.addClass(this.muDesktopPlaceHolder.nativeElement, 'layout-map-fragment');
      }
    }
    if (this.muMobilePlaceHolder) {
      this.positionateMapAndFragment();
    }
  }

  /**
   * remove map fragment associated
   */
  private removeMapFragment() {
    const element = this.mapFragment?.content?.nativeElement as HTMLElement;
    if (!element) {
      this.mapFragment = null;
      return environment.guardClause;
    }
    element.remove();
    if (this.mapFragment?.contentClass) {
      const desktopPlaceHolder = this.getDesktopFragmentPlaceHolder();
      const mobilePlaceHolder = this.getMobileFragmentPlaceHolder();
      this.renderer.removeClass(desktopPlaceHolder.nativeElement, this.mapFragment.contentClass);
      if (mobilePlaceHolder) {
        this.renderer.removeClass(mobilePlaceHolder.nativeElement, this.mapFragment.contentClass);
      }
    }
    if (this.mapFragment?.mapClass) {
      this.renderer.removeClass(
        this.muDesktopPlaceHolder.nativeElement,
        this.mapFragment.contentClass
      );
      this.renderer.addClass(this.muDesktopPlaceHolder.nativeElement, 'layout-map-fragment');
      if (!this.mobileMapPlaceHolder) {
        this.renderer.removeClass(
          this.muMobilePlaceHolder.nativeElement,
          this.mapFragment.contentClass
        );
      }
    }
    this.mapFragment = null;
  }

  /**
   * returns the fragment holder used in desktop
   */
  private getDesktopFragmentPlaceHolder(): ElementRef {
    if (this.mapFragment?.position === LayoutMapFragmentPosition.BOTTOM) {
      return this.muMapFragmentBottomPlaceHolder;
    }
    return this.muMapFragmentTopPlaceHolder;
  }

  /**
   * returns the fragment holder used in mobile
   */
  private getMobileFragmentPlaceHolder(): ElementRef {
    if (this.mapFragment?.mobileMapFragmentHolder) {
      return null;
    }
    if (this.mapFragment?.position === LayoutMapFragmentPosition.BOTTOM) {
      return this.muMapFragmentBottomPlaceHolder;
    }
    return this.muMapFragmentTopPlaceHolder;
  }

  /**
   * check leave to fit bounds
   * @returns
   */
  checkToFitBounds(): void {
    if (!this.mapOptions.fitBoundsOnLeave || this.isDragActive) {
      return environment.guardClause;
    }
    this.muMap.cleanFitBounds();
  }

  /**
   * Ask for browser location permissions and set the location info (Lat and Lng)
   * fot the observer. In case permission are enable, do not try to show modal.
   */
  async askForBrowserLocation(): Promise<void> {
    let enableFlag = true;
    setTimeout(() => {
      if (enableFlag) {
        this.flagList.enable(LayoutPageAndMapModalPositionFlags.SHOW_MODAL_POSITION);
      }
    }, 150);

    const location = await new Promise<SimplyCoordinatesShared>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resp => resolve({ longitude: resp.coords.longitude, latitude: resp.coords.latitude }),
        err => reject(err)
      );
    }).catch(() => null);

    enableFlag = false;
    this.flagList.disable(LayoutPageAndMapModalPositionFlags.SHOW_MODAL_POSITION);

    this.layoutPageAndMapService.setCurrentAddress(location);
  }
}
